// extracted by mini-css-extract-plugin
export var wordContainer = "_pl-0";